<template>
  <div class="job-card">
    <button
      v-if="!disabledRemove"
      type="button"
      class="job-card__btn-remove btn-cross btn-cross--remove btn-reset"
      @click="onRemove"
    />

    <span class="job-card__name">
      {{ job.job_type }}
    </span>

    <p class="job-card__descr">
      {{ job.description ?  job.description : 'Нет описания'}}
    </p>

    <span class="job-card__executor">
      {{ job.executor }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'PtoJobCard',
  props: {
    disabledRemove: {
      type: Boolean,
      default: false
    },
    job: {
      type: Object,
      require: true
    }
  },

  methods: {
    onRemove () {
      this.$emit('onRemove', this.job.id)
    }
  }
}
</script>
